import React from 'react';
import { BookOpenIcon, ClipboardCheckIcon, GiftIcon, MicroscopeIcon, ZapIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
const icons = [BookOpenIcon, GiftIcon, MicroscopeIcon, ClipboardCheckIcon, ZapIcon];

/** The value stack — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-124" data-mp="28a9tulk50xva">
      <div className="mx-auto max-w-5xl" data-id="element-125" data-mp="23g5m4031slt5">
        <SectionHeading id="offer-heading" title={<>
              Everything You Need in <Accent data-id="element-127" data-mp="2vzkywf8itef8">One Teaching System.</Accent>
            </>} data-id="element-126" data-mp="1yk71mnkubny0" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(70,50,110,0.5)]" data-id="element-128" data-mp="2r7t3nref6kir">
          <div className="bg-brand-charcoal px-6 py-4 text-center" data-id="element-129" data-mp="3hgv686scupvf">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-130" data-mp="3hg39gsn0um3k">
              Cosmetology Instructor Ready™ — Complete System
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-131" data-mp="37p8qpy8zi4mv">
            <img src={MOCKUP_URL} alt="Everything included in Cosmetology Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[580px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(91, 63, 176, 0.16))'
          }} data-id="element-132" data-mp="2tqr463utey6j" />

            <ul className="mx-auto mt-10 max-w-xl space-y-3.5" role="list" data-id="element-133" data-mp="iyzf4irmdh8k">
              {offerIncludes.map((item, index) => {
              const Icon = icons[index];
              return <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-134" data-mp="1vy16skr5nfhe" data-mpi={index}>
                    <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-brand-lavender/60" data-id="element-135" data-mp="1qxd8de0ljwd5">
                      <Icon className="h-4 w-4 text-brand-violet" strokeWidth={1.75} aria-hidden="true" data-id="element-136" data-mp="1myxnpgrzn02w" />
                    </span>
                    {item}
                  </li>;
            })}
            </ul>

            <div className="mt-8 border-t border-brand-charcoal/10 pt-8" data-id="element-137" data-mp="2am5l7cj6d4ud">
              <CtaBlock label="Get Cosmetology Instructor Ready Now" showPrice data-id="element-138" data-mp="25vyxdewhlod6" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}